export const EDB_IS_DISABLED_MSG =
  "Cette EDB, son projet, son chantier ou son entreprise est désactivé(e) ou cette EDB est annulée.";
